const __WEBPACK_NAMESPACE_OBJECT__ = require("rc-util/es/Dom/shadow");